import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { useTranslation } from 'react-i18next';

const Nav = () => {
  const scrollProps = { spy: true, smooth: true, duration: 500 };
  const isHomePage = false;
  const { t } = useTranslation('common');

  return (
    <ul className="mainmenu">
      <li className="has-droupdown">
        {isHomePage ? (
          <ScrollLink to="happy-pos" offset={-410} {...scrollProps}>
            {t('navigation.products')}
          </ScrollLink>
        ) : (
          <RouterLink to="/">{t('navigation.products')}</RouterLink>
        )}
        <ul className="submenu">
          <li>
            <RouterLink to="/termekeink/szoftver">{t('navigation.software')}</RouterLink>
          </li>
          <li>
            <RouterLink
              to="/termekeink/szolgaltatasok"
              onClick={() => {
                /* setTimeout(() => {
                  const extrasList = document.querySelector(".extras-list");
                  window.scrollTo(
                    0,
                    extrasList ? extrasList.offsetTop - 150 : 600
                  );
                }, isHomePage ? 1000 : 100); */
              }}
            >
              {t('navigation.services')}
            </RouterLink>
          </li>
          {false && (
            <>
              <li>
                <RouterLink to="/termekeink/ettermi-szoftver">
                  Éttermi szoftver
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/termekeink/mobil-pincer-app">
                  Mobil pincér app
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/termekeink/hazhozszallitas-modul">
                  Házhozszállítás modul
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  aria-disabled={"true"}
                  to="#/termekeink/management-statisztikak"
                >
                  Management statisztikák
                </RouterLink>
              </li>
            </>
          )}
        </ul>
      </li>
      <li>
        <RouterLink to="/profilom">{t('navigation.profile')}</RouterLink>
      </li>
      {false && (
        <li>
          <RouterLink to="/termekeink/eszkozok">{t('navigation.ourTools')}</RouterLink>
        </li>
      )}
      {false && (
        <li>
          <RouterLink to="/profilom">{t('navigation.profile')}</RouterLink>
        </li>
      )}
      {false && (
        <li>
          <RouterLink to="/demo">{t('navigation.requestDemo')}</RouterLink>
        </li>
      )}
      <li className={"has-droupdown"}>
        <RouterLink to="/szolgaltatasok/arajanlat">{t('navigation.pricing')}</RouterLink>
        <ul className="submenu">
          <li>
            <RouterLink to="/szolgaltatasok/arajanlat/csomag-arak">
              {t('navigation.packagePrices')}
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/szolgaltatasok/arajanlat/modul-arak">
              {t('navigation.modulePrices')}
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/szolgaltatasok/arajanlat/szolgaltatas-arak">
              {t('navigation.servicePrices')}
            </RouterLink>
          </li>
        </ul>
      </li>
      {false && (
          <li>
            <RouterLink to="/szolgaltatasok/partner/regisztracio">
              {t('navigation.registration')}
            </RouterLink>
        </li>
      )}

      {false && (
        <li>
          <RouterLink to="/partner-program">{t('navigation.partnerProgram')}</RouterLink>
        </li>
      )}

      <li>
        <RouterLink to="/kapcsolat/ugyfelszolgalat">{t('navigation.customerService')}</RouterLink>
      </li>
      {false && (
        <li className="has-droupdown">
          <RouterLink to="/kapcsolat/ugyfelszolgalat">
            {t('navigation.customerService')}
          </RouterLink>
          {
            <ul className="submenu">
              <li>
                <RouterLink to="/kapcsolat/ugyfelszolgalat">
                  {t('navigation.contactUs')}
                </RouterLink>
              </li>
              {false && (
                <li>
                  <RouterLink to="/kapcsolat/tudastar">{t('navigation.knowledgeBase')}</RouterLink>
                </li>
              )}
            </ul>
          }
        </li>
      )}

      {false && (
        <li>
          <RouterLink to="/gyik">{t('navigation.faq')}</RouterLink>
        </li>
      )}
    </ul>
  );
};
export default Nav;
